import { render } from "./archived_students.vue?vue&type=template&id=6255dc27"
import script from "./archived_students.vue?vue&type=script&lang=js"
export * from "./archived_students.vue?vue&type=script&lang=js"

import "./archived_students.vue?vue&type=style&index=0&id=6255dc27&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__